'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = require('d3');

var interpolate = function interpolate(type) {
  switch (type) {
    case 'stepBefore':
      return _d.curveStepBefore;

    case 'stepAfter':
      return _d.curveStepAfter;

    case 'basis':
      return _d.curveBasis;

    case 'basisOpen':
      return _d.curveBasisOpen;

    case 'basisClosed':
      return _d.curveBasisClosed;

    case 'bundle':
      return _d.curveBundle;

    case 'cardinal':
      return _d.curveCardinal;

    case 'cardinalOpen':
      return _d.curveCardinalOpen;

    case 'cardinalClosed':
      return _d.curveCardinalClosed;

    case 'natural':
      return _d.curveNatural;

    default:
      return _d.curveLinear;
  }
};

exports.default = interpolate;
module.exports = exports['default'];